// =============================================================================
// Orders Types
// Orders are quotes filtered to order-stage statuses.
// Re-exports shared types from quotes feature.
// =============================================================================

export type {
  Quote,
  QuoteStatus,
  QuotesFilters,
  QuotesResponse,
  QuoteStatusStats,
  Organisation,
  V3Quote,
  CreateQuoteInput,
  UpdateQuoteInput,
  User,
  PopulatedOrganisation,
  PopulatedUser,
  PopulatedContract,
  PopulatedSite,
  Currency,
  Language,
  TaxCategory,
  PaymentTerms,
  DealType,
} from '@/features/quotes/types';

export {
  isPopulatedOrganisation,
  isPopulatedUser,
  isPopulatedContract,
  isPopulatedSite,
  getAccountName,
  getSalesManagerName,
  getContractualManagerName,
  getQuoteTotal,
  isQuoteExpired,
  isExpirationApproaching,
  calculateTax,
  calculateTotalWithTax,
} from '@/features/quotes/types';

import type { QuoteStatus } from '@/features/quotes/types';

/**
 * Order statuses - the 5 statuses that define the "order" stage
 */
export const ORDER_STATUSES: QuoteStatus[] = [
  'approved',
  'confirmed',
  'inprogress',
  'invoice-ready',
  'partially-invoiced',
  'invoiced',
];

/**
 * Column keys for the orders table
 */
export type OrderColumnKey =
  | 'quoteNumber'
  | 'status'
  | 'createdAt'
  | 'accountName'
  | 'projectName'
  | 'salesManager'
  | 'total'
  | 'expirationDate'
  | 'acceptedDate'
  | 'contractualManager'
  | 'poNumber'
  | 'actions';

/**
 * Default visible columns for the orders table
 */
export const DEFAULT_VISIBLE_ORDER_COLUMNS: OrderColumnKey[] = [
  'quoteNumber',
  'status',
  'acceptedDate',
  'accountName',
  'projectName',
  'salesManager',
  'total',
  'poNumber',
  'actions',
];

/**
 * Form data for creating/editing an order
 */
export interface OrderFormData {
  customer: string;
  project_name: string;
  sales_manager: string;
  status?: QuoteStatus;
  dealtype?: string;
  currency?: string;
  language?: string;
  tax_category?: string;
  payment_terms?: string;
  date?: string;
  expiration_date?: string;
  estimated_delivery?: string;
  accepted_at?: string;
  description?: string;
  comment?: string;
  internal_notes?: string;
  contract?: string;
  subscription?: string;
  contractual_manager?: string;
  billing_site?: string;
  billing_address?: string;
  shipping_addresses?: Array<{
    site?: string;
    name?: string;
    address?: string;
  }>;
  po_number?: string;
  hubspot_link?: string;
  gdrive_link?: string;
  tracking_numbers?: string[];
  next_step?: string;
  next_step_deadline?: string;
}
